export enum AuditLogComponent {
  UserManagement = 1,
  Locations = 2,
  Shifts = 3,
  ActivityTypes = 4,
  Programs = 5,
  Groups = 6,
  AgencyInformation = 7,
  FormsSettings = 8,
  Phases = 9,
  PerformanceCategories = 10,
  Ratings = 11,
  ProgramSkills = 12,
  QuizzesSettings = 13,
  Alerts = 14,
  IncidentTypes = 15,
  CorrectiveActions = 16,
  Users = 17,
  UserProfile = 18,
  Resources = 19,
  Schedule = 20,
  Forms = 21,
  Reports = 22,
  Quizzes = 23,
  AddOns = 25,
  ProgramExitTypes = 26,
  TrainingCourses = 27,
  ProgramTasks = 28,
  SiteCallTypes = 29,
  SiteSkills = 30,
  Search = 31,
  Skills = 32
}
